import { instance as getApi, apiUrl } from '@/helpers/api.js';
import { getI18n } from './i18n';
import { useBrowserSession } from '@kp/geofy-vuejs-lib/tools/browser_session.js';

/** only used when localStorage is not available */
// let noStorageCsrfToken: string | null = null;

const browserSession = useBrowserSession('eplan');

/**
 * Stores the CSRF token in the browser's localStorage
 * for further use during the session.
 *
 * This is needed to support multiple browser windows.
 *
 * @param {String} token
 */
export function storeCsrfToken(token: string) {
    browserSession.setSessionValue('csrfToken', token);
    // if (Storage) {
    //     localStorage.setItem('eplan.csrfToken', token);
    // } else {
    //     noStorageCsrfToken = token;
    // }
}

/**
 * Retrieves the csrf token from the browser's
 * local storage
 */
export function getCsrfToken() {
    return browserSession.getSessionValue('csrfToken') ?? '';
    // if (Storage) {
    //     return localStorage.getItem('eplan.csrfToken') ?? '';
    // } else {
    //     return noStorageCsrfToken ?? '';
    // }
}

type LoginResponse = {
    user: any;
    redirectUrl: string;
};

export async function login(username: string, password: string): Promise<LoginResponse> {
    try {
        const response = await getApi().post('/auth/login', {
            username: username,
            password: password
        });
        if (response.data.user) {
            let redirectUrl = '/';
            const split = window.location.href.split('?redirect=');
            if (split.length === 2) {
                redirectUrl = split[1];
            }
            return { user: response.data.user, redirectUrl: redirectUrl };
        } else {
            throw new Error(getI18n().t('denied_wrong_login'));
        }
    } catch (e) {
        throw new Error(getI18n().t('denied_wrong_login'));
    }
}

export async function logout() {
    //return await getApi().get('/auth/logout');
    let url = '/auth/logout';
    window.location.href = apiUrl(url);
}

export async function verifyUser(password: string) {
    try {
        const response = await getApi().post('/auth/verifyUser', {
            password: password
        });
        return response.data.verified;
    } catch (e) {
        throw new Error('Hoppla, da ist was schief gelaufen...');
    }
}

export default {
    login,
    logout,
    verifyUser
    // resetPassword,
};
